import React from "react";
import { dateToString, thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

const CorpInfo = ({ portfolio }) => {
	const { t } = useTranslation();

	return (
		<li>
			<div className="title-group">
				<h3 className="basic-info-title">
					{t("pages.portfolio.PortfolioView.components.CorpInfo.info")}
				</h3>
			</div>
			<ul className="basic-info-content">
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.companyNumber")} :{" "}
					{portfolio.regNum || "-"}
				</li>
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.corpNumber")} :{" "}
					{portfolio.corpNum || "-"}
				</li>
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.present")} :{" "}
					{portfolio.ceoName || "-"}
				</li>
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.type")} :{" "}
					{portfolio.industryCondition || "-"}
				</li>
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.location")} :{" "}
					{!portfolio.address && !portfolio.addressDetail
						? "-"
						: `${portfolio.address} ${portfolio.addressDetail}`}
				</li>
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.estDate")} :{" "}
					{portfolio.estDate ? dateToString(portfolio.estDate, "yyyy. MM. dd") : "-"}
				</li>
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.employeeNum")} :{" "}
					{thousandFormatter(portfolio.employeeNum) ?? "-1"}
					{t("pages.portfolio.PortfolioView.components.CorpInfo.num")}
				</li>
				<li>
					{t("pages.portfolio.PortfolioView.components.CorpInfo.fieldIndustry")} :{" "}
					{portfolio?.StartupIndustry?.length > 0
						? portfolio?.StartupIndustry?.map((industry) => {
								return industry.IndustryKeywords?.name;
						  }).join(", ")
						: "-"}
				</li>
				<li className="c__tag-wrap">
					{portfolio?.StartupKeyword?.map((keyword) => {
						return (
							<span key={keyword.idx} className="c__tag-view">
								{keyword.title}
							</span>
						);
					})}
				</li>
			</ul>
		</li>
	);
};

export default CorpInfo;
